// Define Klaviyo global object if not already defined
var klaviyo = klaviyo || [];

/**
 * Initializes Klaviyo Back In Stock modal and behavior
 */
function initializeKlaviyo() {
  klaviyo.init({
    account: 'NynWcE',
    list: 'NHicJY',
    platform: 'shopify',
  });

  klaviyo.enable('backinstock', {
    trigger: {
      product_page_text: 'Notify Me When Available',
      product_page_class: 'button solid',
      product_page_text_align: 'center',
      product_page_margin: '0px',
      replace_anchor: true,
    },
    modal: {
      headline: '{product_name}',
      body_content: 'Register to receive a notification when this item comes back in stock.',
      email_field_label: 'Email',
      button_label: 'Notify me when available',
      subscription_success_label: "You're in! We'll let you know when it's back.",
      footer_content:
        'By selecting "I consent" above, you agree to receive recurring automated notifications from Abaco at the email address provided. Consent is not a condition of any purchase. More information can be found in our <a href="https://abacopolarized.com/pages/terms-and-conditions" target="_blank">Terms</a> & <a href="https://abacopolarized.com/pages/privacy-policy" target="_blank">Privacy</a>.',
      drop_background_color: '#000',
      background_color: '#fff',
      text_color: '#4A4A4A',
      button_text_color: '#fff',
      button_background_color: '#1C8CD4',
      close_button_color: '#ccc',
      error_background_color: '#fcd6d7',
      error_text_color: '#C72E2F',
      success_background_color: '#d3efcd',
      success_text_color: '#1B9500',
      newsletter_subscribe_label: 'I consent to receive future emails from ABACO.',
      subscribe_checked: true,
    },
  });
}

// Load Klaviyo's onsite script and initialize when ready
window.addEventListener('load', function () {
  var script = document.createElement('script');
  script.src = "https://a.klaviyo.com/media/js/onsite/onsite.js";
  script.defer = true;
  
  script.onload = function () {
    initializeKlaviyo();
  };

  script.onerror = function () {
    console.error('Failed to load Klaviyo script');
  };

  document.head.appendChild(script);
});
